<template>
  <div>
    <div v-if="user">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="me-3">
              <div style="cursor: pointer" @click="showProfileImageModal">
                <b-avatar
                    size="60px"
                    :src="userImage"
                    variant="light">
                </b-avatar>
              </div>
            </div>
            <div class="media-body align-self-center">
              <div class="text-muted">
                <h5>{{ user.name }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProfileImageModal @imgStr="setUserImage" :initial="userImage"></ProfileImageModal>
  </div>
</template>

<script>
import ProfileImageModal from "./ProfileImageModal";
import 'vue-croppa/dist/vue-croppa.css';
import UserService from "../../../Services/Api/UserService";

export default {
  name: "TopCard",
  props: {
    user: {
      default: {}
    }
  },
  components: {
    ProfileImageModal,
  },
  watch: {
    user(user) {
      this.userImage = user.avatar
    }
  },
  data() {
    return {
      userImage: null
    }
  },
  methods: {
    showProfileImageModal() {
      this.$bvModal.show('profile-image-modal')
    },
    async setUserImage(e) {
      this.userImage = e
      const payload = {
        img: e
      }
      await UserService.updateAvatar({payload}).then(() => {
        this.$auth.fetch()
      })
    }
  },
}
</script>

<style scoped>

.img-avatar {
  color: transparent;
  position: absolute;
  cursor: pointer;
}

.avatar-icon {

}
</style>
